import { alert } from '@/shared/ui/dialog'

import { formatStoreCloseDay, formatStoreCloseTime } from './storeHours'

/**
 * O aviso de lojinha fechada, numa voz só.
 *
 * Três caminhos levam a ele — tocar num item fora da janela, enviar um resgate
 * que a api recusa com `reward_shop_closed`, e a corrida entre os dois — e os
 * três tinham que dizer a mesma coisa. Quando há próxima abertura, ela é a
 * informação que o Participante usa; sem ela, prometer horário seria inventar.
 */
export const storeClosedDescription = (openAt?: {
  isValid?: boolean
} | null): string => {
  const time = formatStoreCloseTime(openAt as never)

  if (!time) {
    return 'A lojinha não está aberta para resgate agora. Fique de olho: o resgate volta quando ela abrir.'
  }

  const day = formatStoreCloseDay(openAt as never)

  return day
    ? `A lojinha não está aberta para resgate agora. Ela abre ${day}, às ${time}.`
    : `A lojinha não está aberta para resgate agora. Ela abre às ${time}.`
}

export const showStoreClosedAlert = (openAt?: { isValid?: boolean } | null) =>
  alert({
    variant: 'destructive',
    title: 'Lojinha fechada',
    description: storeClosedDescription(openAt)
  })

export const STORE_CLOSED_CODE = 'reward_shop_closed'

/**
 * A api recusa o resgate fora da janela com `reward_shop_closed`, e entrega o
 * código dentro de uma frase humanizada pelo Rails ("Reward item
 * reward_shop_closed"). Procurar o **código** e não a frase é o que mantém
 * isto de pé quando a mensagem for traduzida.
 *
 * O botão já impede o toque; este caminho existe para a corrida — a janela
 * fecha entre o carregamento da tela e o envio, e aí quem sabe é o servidor.
 */
export const isStoreClosedError = (error: unknown): boolean => {
  const payload = (error as { response?: { data?: unknown } })?.response?.data

  if (!payload) return false

  try {
    return JSON.stringify(payload).includes(STORE_CLOSED_CODE)
  } catch {
    return false
  }
}
